import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBeggingHandCoin2 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.94,16.06a3.92,3.92,0,0,0-1.78.42L.14,18a.24.24,0,0,0-.14.22v5.4a.23.23,0,0,0,.13.21.23.23,0,0,0,.25,0L3.8,21.68a.48.48,0,0,1,.42-.05c10.26,3.44,6.78,3.5,18.11-2.23a.51.51,0,0,0,.08-.86A2.45,2.45,0,0,0,20,18.06l-3.42,1.13a.48.48,0,0,0-.29.25,2,2,0,0,1-1.79,1.12h-4a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h4a1,1,0,1,0,0-2H11.17a.54.54,0,0,1-.3-.1A6.92,6.92,0,0,0,7,16.06Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.5,0A6.5,6.5,0,1,0,24,6.5,6.51,6.51,0,0,0,17.5,0Zm.75,10.24v.51a.75.75,0,0,1-1.5,0v-.5H16a.75.75,0,0,1,0-1.5h2a.59.59,0,0,0,.22-1.14l-2.06-.83a2.09,2.09,0,0,1,.56-4V2.25a.75.75,0,0,1,1.5,0v.5H19a.75.75,0,0,1,0,1.5H17a.59.59,0,0,0-.59.59.58.58,0,0,0,.37.55l2.06.83a2.09,2.09,0,0,1-.56,4Z",
		fill: "currentColor"
	})] })
});
export { SvgBeggingHandCoin2 as ReactComponent };
